<div class="d-flex align-items-center gap-3 mb-4" [class.grayscale]="fa().Disabled">
    <img [src]="getBankLogoByName(fa().Bank)" style="max-width: 42px; max-height: 42px;">
    <div class="flex-fill">
        <div class="fs-5 fw-semibold">
            {{ fa().Description }} @if (fa().Disabled) { <span class="badge text-danger-emphasis bg-danger-subtle border border-danger-subtle text-uppercase fs-6">Disabled</span> }
        </div>
        <div class="text-secondary">
            <span class="fw-semibold">{{ fa().Code }}</span>
            @if (fa().AccNumber?.length > 0) { | {{ fa().AccNumber }} }
            @if (fa().Directors?.length > 0) { | {{ fa().Directors }} }
        </div>
    </div>
</div>
<h6 class="fw-bold text-secondary">Businesses ({{ businessList().linked.length }})</h6>
@if (!fa().Disabled) {
    <div class="d-flex gap-2">
        <app-select-business-license class="flex-fill" [businessOnly]="true" [customBusinessList]="businessList().selection" [(businessId)]="selectedBusiness"></app-select-business-license>
        <button class="btn btn-outline-primary" [disabled]="selectedBusiness() == null" (click)="link()"><i class="fas fa-link"></i> Link</button>
    </div>
}
<div class="acc-list">
@for (b of businessList().linked; track b.Id; let i = $index) {
    <div class="list-item d-flex gap-2 align-items-center">
        <div class="flex-fill lh-sm">
            <div class="fw-semibold">{{ b.Name }}</div>
            <small class="text-secondary">{{ b.Directors }}</small>
        </div>
        <i class="fas fa-unlink text-secondary pointer" [tabindex]="0" (click)="unlink(b)"></i>
    </div>
}
</div>
